import { format, parseISO } from "date-fns";

export const dateToPortalDisplay = (date: Date) => {
  return format(date, "eee dd MMM yyyy, hh:mm aaa");
};

export const formatDateWithoutOrdinal = (dateString: string): string => {
  const date = parseISO(dateString);
  return format(date, "MMMM d yyyy");
};

export const formatDateWithSmallMonth = (dateString: string): string => {
  const date = parseISO(dateString);
  return format(date, "MMMM d yyyy");
};

export const formatTimeFromDate = (dateString: string): string => {
  const date = parseISO(dateString);
  return format(date, "hh:mm aaa");
};

export const formatDateWithTime = (dateString: string): string => {
  const date = parseISO(dateString);
  return format(date, "MMMM d yyyy, hh:mm aaa");
};

export const relativeDateAndTimeFormat = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();

  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  const isYesterday =
    date.getDate() === now.getDate() - 1 &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  const time = date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  if (isToday) {
    return `today at ${time}`;
  } else if (isYesterday) {
    return `yesterday at ${time}`;
  } else {
    const formattedDate = date.toLocaleDateString([], {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
    return `${formattedDate} at ${time}`;
  }
};
